/* -----------------UI--------------- */
import { List, type ListItemProps, Text } from "react-native-paper";

import Icon from "@expo/vector-icons/MaterialCommunityIcons";
/* -----------------Child components--------------- */
import CustomChip from "@memorang/ui/components/CustomChip";
import { OverlineText } from "@memorang/ui/components/OverlineText";
import type { IconType } from "@memorang/ui/icon";

type Props = {
	rightText?: string;
	icon?: string;
	iconColor?: string;
} & ListItemProps;

const StatListItem = (props: Props) => {
	const { icon, iconColor, title, description, rightText } = props;

	return (
		<List.Item
			style={{
				paddingRight: 0,
			}}
			left={() => (
				<List.Icon
					icon={(props) => (
						<Icon {...props} name={icon as IconType} color={iconColor} />
					)}
				/>
			)}
			title={<OverlineText>{description as string}</OverlineText>}
			description={<Text>{title as string}</Text>}
			right={(p) =>
				rightText ? <CustomChip {...p}>{rightText}</CustomChip> : null
			}
		/>
	);
};

export default StatListItem;
